import '.a6{color:var(--brand-secondary);}.ssr-plugin'
import '.a7{font-family:FunnelDisplay;}.ssr-plugin'
import '.a8{font-weight:400;}.ssr-plugin'
import '.a9{font-style:normal;}.ssr-plugin'
import '.aa{font-size:1.5rem;}.ssr-plugin'
import '.ab{line-height:140%;}.ssr-plugin'
import useMediaQuery from '@app/util/useMediaQuery'
import { styled, type Style } from 'inlines'
import type { ReactNode } from 'react'
import { match } from 'ts-pattern'
import {
  getTitleLevelStyle,
  type TitleLevel,
} from '@app/components/core/typography/styles'

export type TextProps = {
  children: ReactNode
  style?: Style
}

export type PageTitleProps = TextProps & {
  styledAsLevel?: TitleLevel
}

const Heading = ({
  level,
  children,
  style,
}: TextProps & { level: TitleLevel }) => {
  const isMobile = useMediaQuery()
  const levelStyle = getTitleLevelStyle(level, isMobile)

  switch (level) {
    case 1:
      return (
        <styled.h1 style={{ ...levelStyle, ...style }}>{children}</styled.h1>
      )
    case 2:
      return (
        <styled.h2 style={{ ...levelStyle, ...style }}>{children}</styled.h2>
      )
    case 3:
      return (
        <styled.h3 style={{ ...levelStyle, ...style }}>{children}</styled.h3>
      )
    case 4:
      return (
        <styled.h4 style={{ ...levelStyle, ...style }}>{children}</styled.h4>
      )
    case 5:
      return (
        <styled.h5 style={{ ...levelStyle, ...style }}>{children}</styled.h5>
      )
  }
}

const Page = ({ children, style, styledAsLevel = 1 }: PageTitleProps) => {
  const isMobile = useMediaQuery()

  return (
    <h1 style={{ ...getTitleLevelStyle(styledAsLevel, isMobile), ...style }}>
      {children}
    </h1>
  )
}

const H1 = (props: TextProps) => <Heading level={1} {...props} />
const H2 = (props: TextProps) => <Heading level={2} {...props} />
const H3 = (props: TextProps) => <Heading level={3} {...props} />
const H4 = (props: TextProps) => <Heading level={4} {...props} />
const H5 = (props: TextProps) => <Heading level={5} {...props} />

const TitleRoot = ({ children }: { children: React.ReactNode }) => {
  return children
}

const TitlePropsBased = (
  props: TextProps & {
    title: 'H1' | 'H2' | 'H3' | 'H4' | 'H5'
  },
) => {
  return match(props.title)
    .with('H1', () => H1(props))
    .with('H2', () => H2(props))
    .with('H3', () => H3(props))
    .with('H4', () => H4(props))
    .with('H5', () => H5(props))
    .exhaustive()
}

TitleRoot.H1 = H1
TitleRoot.H2 = H2
TitleRoot.H3 = H3
TitleRoot.H4 = H4
TitleRoot.H5 = H5
TitleRoot.Page = Page
TitleRoot.Hx = TitlePropsBased

export const Title = TitleRoot

export const Subtitle = ({ children, style }: TextProps) => {
  return (
    <styled.div className="a6 a7 a8 a9 aa ab"
      role="doc-subtitle"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.div>
  )
}
